import { CheckboxProps } from "antd";
import { ConfigProvider } from "antd";
import { StyledCheckbox, StyledCheckboxGroup } from "./atom";

export function Checkbox({ className = "", ...props }: CheckboxProps) {
  return (
    <ConfigProvider>
      <StyledCheckbox
        className={`renderbus-ui--checkbox ${className}`}
        {...props}
      />
    </ConfigProvider>
  );
}

Checkbox.Group = StyledCheckboxGroup;
